import { useReducer, useRef } from "react";
import { useDispatch } from "react-redux";
import useHttp from "../../../hooks/use-http";
import { authActions } from "../../../store/auth";
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points";

import { useEffect } from "react";

import { saveLocalData } from "../../../helpers/storage-helper";
import { useHistory } from "react-router-dom";
import { cuteToast } from "../../UI/cute";

const emailReducer = (state, action) => {
  switch (action.type) {
    case "USER_INPUT":
      return {
        value: action.value,
        isValid: /\S+@\S+\.\S+/.test(action.value),
      };
    case "USER_INPUT_BLUR":
      return { value: state.value, isValid: /\S+@\S+/.test(state.value) };
    default:
      return { value: "", isValid: false };
  }
};

const passwordReducer = (state, action) => {
  switch (action.type) {
    case "USER_INPUT":
      return { value: action.value, isValid: action.value.trim().length > 6 };
    case "USER_INPUT_BLUR":
      return { value: state.value, isValid: state.value.trim().length > 0 };
    default:
      return { value: "", isValid: false };
  }
};

const Login = () => {
  const history = useHistory();
  const [emailState, dispatchEmail] = useReducer(emailReducer, {
    value: "",
    isValid: null,
  });
  const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
    value: "",
    isValid: null,
  });
  const dispatch = useDispatch();

  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: logInRequest,
  } = useHttp();

  const emailRef = useRef();
  const passwordRef = useRef();

  const responseHandle = (response) => {
    saveLocalData("vidamaze_user", response);
    dispatch(
      authActions.login({
        token: response.token,
        roles: response.roles,
        first_name: response.first_name,
        last_name: response.last_name,
        access: response.access,
        email: response.email,
        video_credits: response.video_credits,
      })
    );
    history.push("/");
  };

  const submitHandler = (event) => {
    event.preventDefault();

    if (!emailState.isValid) {
      emailRef.current.focus();
      dispatchEmail({ type: "USER_INPUT_BLUR" });
    } else if (!passwordState.isValid) {
      passwordRef.current.focus();
      dispatchPassword({ type: "USER_INPUT_BLUR" });
    }

    if (emailState.isValid && passwordState.isValid) {
      const userData = {
        username: emailState.value,
        password: passwordState.value,
      };

      logInRequest(
        {
          url: endPoints.login,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: userData,
        },
        responseHandle
      );
    }
  };

  const emailChangeHandler = (event) => {
    dispatchEmail({ type: "USER_INPUT", value: event.target.value });
  };

  const validateEmail = () => {
    dispatchEmail({ type: "USER_INPUT_BLUR" });
  };

  const passwordChangeHandler = (event) => {
    dispatchPassword({ type: "USER_INPUT", value: event.target.value });
  };

  const validatePassword = () => {
    dispatchPassword({ type: "USER_INPUT_BLUR" });
  };

  useEffect(() => {
    // console.log(httpStatusCode);

    if (error && httpStatusCode) {
  
      //  let icon  = httpStatusCode === 404 ? "fa-user-slash" : "fa-key";
      //  console.log(icon)
      // dispatch(
      //   alertAction.showAlert({
      //     action: "show",
      //     alert_txt: error,
      //     alert_class: "danger",
      //     alert_icon: icon,
      //   })
      // );
      setError(null);
      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "",
      });
    }
  });
  return (
    <>
      <form onSubmit={submitHandler} method="post">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
          className="img-fluid"
          alt="img"
        />

        <h1 className="p2">Sign in</h1>
        {/* <span>or use your account</span> */}
        {error && <h3>{error}</h3>}
        <Input
          ref={emailRef}
          type="email"
          placeholder="Enter Your Email"
          onChange={emailChangeHandler}
          onBlur={validateEmail}
          inputClass={`${
            emailState.isValid === false ? "invalid" : ""
          } rounded`}
        />
        <Input
          ref={passwordRef}
          type="password"
          placeholder="Enter Your Password"
          onChange={passwordChangeHandler}
          onBlur={validatePassword}
          inputClass={`${
            passwordState.isValid === false ? "invalid" : ""
          } rounded`}
        />
        <button type="submit">Sign In</button>
      </form>
    </>
  );
};

export default Login;
